export default __webpack_public_path__ + "static/media/museum-logo.fa24eb4e.svg";